// removed by extract-text-webpack-plugin
module.exports = {"selectNumberContainer":"styles__selectNumberContainer___2CPh-","descriptionContainer":"styles__descriptionContainer___3PZMs","numberItemsClass":"styles__numberItemsClass___3NReA","inputClass":"styles__inputClass___110kO"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/NewInterfaceOnline/components/StepModals/components/StepAddNumbers/styles.css
// module id = 2876
// module chunks = 0